<app-header></app-header>
<div class="vac">
  <aside class="vac-list" [class.hide-on-phone]="active">
    <div class="vac-list-head">
      <h2>Chats</h2>
      <p>Read only — View as cannot send, react or change anything.</p>
      <input type="search" [(ngModel)]="query" placeholder="Search chats" aria-label="Search chats" />
    </div>
    @if (loading) {
      <div class="vac-empty">Loading chats…</div>
    } @else if (error) {
      <div class="vac-empty error">{{ error }}</div>
    } @else if (!filtered.length) {
      <div class="vac-empty">No chats</div>
    } @else {
      <ul>
        @for (c of filtered; track c.channelId) {
          <li>
            <button type="button" class="vac-row" [class.on]="active?.channelId === c.channelId" (click)="open(c)">
              <img [src]="avatar(c)" alt="" />
              <span class="vac-row-text">
                <span class="vac-row-name">{{ name(c) }}</span>
                <span class="vac-row-preview">{{ preview(c) }}</span>
              </span>
            </button>
          </li>
        }
      </ul>
    }
  </aside>

  <section class="vac-thread" [class.hide-on-phone]="!active">
    @if (!active) {
      <div class="vac-empty">Pick a chat to read it.</div>
    } @else {
      <header class="vac-thread-head">
        <button type="button" class="vac-back" (click)="active = null" aria-label="Back to chats">
          <span class="material-symbols-outlined">arrow_back</span>
        </button>
        <img [src]="avatar(active)" alt="" />
        <span class="vac-thread-name">{{ name(active) }}</span>
        <span class="vac-badge">Read only</span>
      </header>
      <div class="vac-messages">
        @if (hasOlder) {
          <button type="button" class="vac-older" (click)="loadOlder()" [disabled]="loadingMessages">
            {{ loadingMessages ? 'Loading…' : 'Load older messages' }}
          </button>
        }
        @if (messagesError) {
          <div class="vac-empty error">{{ messagesError }}</div>
        }
        @if (loadingMessages && !messages.length) {
          <div class="vac-empty">Loading messages…</div>
        } @else if (!messages.length && !messagesError) {
          <div class="vac-empty">No messages</div>
        }
        @for (m of messages; track m._id || $index) {
          @if (isSystem(m)) {
            <div class="vac-system">{{ m.message }} <span>{{ when(m) }}</span></div>
          } @else {
            <div class="vac-msg" [class.mine]="mine(m)">
              <div class="vac-msg-meta">{{ m.senderName || 'Someone' }} · {{ when(m) }}</div>
              @if (fileUrl(m)) {
                @if (isImage(m)) {
                  <a [href]="fileUrl(m)" target="_blank" rel="noopener"><img class="vac-img" [src]="fileUrl(m)" [alt]="fileName(m)" /></a>
                } @else {
                  <a class="vac-file" [href]="fileUrl(m)" target="_blank" rel="noopener">
                    <span class="material-symbols-outlined">description</span>{{ fileName(m) }}
                  </a>
                }
              }
              @if (m.message && !(fileUrl(m) && m.message === fileName(m))) {
                <div class="vac-msg-text">{{ m.message }}</div>
              }
            </div>
          }
        }
      </div>
      <footer class="vac-foot">Read only — replies, reactions and files are off in View as.</footer>
    }
  </section>
</div>
